import logo from './logo.svg';
import './App.css';
// import GenA from '.  /Genetic ALgo/GenA';
// import Sine1 from './sine_sim/Sine1';
import Pi from './Pi.js/Pi';
import Color_m from './Colour_pred/Color_m';
import Cnn1 from './CNN_ml/Cnn1';
import Cnn2 from './CNN_ml_ditto/Cnn2';
// import Flappy_Bird from './Flappy_bird';
import Flappy_Bird from './flappy_bird/Flappy_Bird';
// import Test from './Test_fb/Test';
import Moli from './Mono_lisa_main/Moli';
import Pn1 from './Pose_net1/Pn1';
import Pn2 from './Pose_net1/Pn2';
import Game1 from './Game_2048/Game1';
import Game2 from './Game_4096/Game2';

function App() {
  return (
    <div className="App">
      {/* <GenA /> */}
      {/* <Sine1 /> */}
      {/* <Pi /> */}
      {/* <Color_m /> */}
      {/* <Cnn1 /> */}
      {/* <Cnn2 /> */}
      {/* <Flappy_Bird /> */}
      {/* <Pn1 /> */}
      {/* <Pn2 /> */}
      {/* <Game1 /> */}
      <Game2 />
      {/* <Test /> */}
      {/* <Moli /> */}
      </div>
  );
}

export default App;
